import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import { _EDIT } from '@shell/config/query-params';
import { CONFIG_MAP } from '@shell/config/types';
import { PaginationParamFilter } from '@shell/types/store/pagination.types';
import ResourceLabeledSelect from '@shell/components/form/ResourceLabeledSelect.vue';

interface ConfigMap {
  id?: string;
  name: string;
  namespace: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FleetConfigMapSelector',
  props: {
  value: {
    type:     Object,
    required: true,
  },
  namespace: {
    type:     String,
    required: true,
  },
  inStore: {
    type:    String,
    default: 'management',
  },
  mode: {
    type:    String,
    default: _EDIT
  },
  label: {
    type:    String,
    default: '',
  },
},
  emits: ['update:value'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const configMaps = ref<ConfigMap[]>([]);

const allConfigMapsSettings = {
  updateResources: (configMapsList: ConfigMap[]) => {
    const allConfigMapsInNamespace = configMapsList.filter((configMap) => configMap.namespace === props.namespace);
    const mappedConfigMaps = mapConfigMaps(allConfigMapsInNamespace.sort((a, b) => a.name.localeCompare(b.name)));

    configMaps.value = allConfigMapsInNamespace;

    return mappedConfigMaps;
  }
};

const paginateConfigMapsSetting = {
  requestSettings: paginatePageOptions,
  updateResources: (configMapsList: ConfigMap[]) => {
    const mappedConfigMaps = mapConfigMaps(configMapsList);

    configMaps.value = configMapsList;

    return mappedConfigMaps;
  }
};

function mapConfigMaps(configMapsList: ConfigMap[]) {
  return configMapsList.reduce<{ label: string; value: string }[]>((res, c) => {
    if (c.id) {
      res.push({ label: c.name, value: c.name });
    } else {
      res.push(c as any);
    }

    return res;
  }, []);
}

function paginatePageOptions(opts: any) {
  const { opts: { filter } } = opts;

  const filters = !!filter ? [PaginationParamFilter.createSingleField({
    field: 'metadata.name', value: filter, exact: false, equals: true
  })] : [];

  filters.push(
    PaginationParamFilter.createSingleField({ field: 'metadata.namespace', value: props.namespace }),
  );

  return {
    ...opts,
    filters,
    groupByNamespace: false,
    classify:         true,
    sort:             [{ asc: true, field: 'metadata.name' }],
  };
}

function update(value: any) {
  emit('update:value', value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ResourceLabeledSelect, {
    key: __props.namespace,
    value: __props.value,
    label: __props.label || _ctx.t('fleet.configMaps.label'),
    mode: __props.mode,
    "resource-type": _unref(CONFIG_MAP),
    loading: _ctx.$fetchState.pending,
    "in-store": __props.inStore,
    "paginated-resource-settings": paginateConfigMapsSetting,
    "all-resources-settings": allConfigMapsSettings,
    multiple: true,
    "onUpdate:value": update
  }, null, 8, ["value", "label", "mode", "resource-type", "loading", "in-store"]))
}
}

})